(() => {
  const sections = document.querySelectorAll("section");

  // 監視対象にクラスを付与（必要なら除外も可能）
  sections.forEach((sec) => {
    // 例：ヘッダー直下の hero も対象にしたいならそのまま
    // sec.classList.add("js-fade-section");

    // 例：最初から表示したいセクションは除外したいならコメント外して使う
    // if (sec.classList.contains("hero")) return;

    sec.classList.add("js-fade-section");

    // セクション内の「ふわっと段差表示」させたい直下要素に付ける（任意）
    // ここでは「見出し/主要ブロック」をざっくり対象にしています
    const candidates = sec.querySelectorAll(
      ":scope > .container-l, :scope > .container-m, :scope > .container-s, h2, h3, .contact-cta"
    );
    candidates.forEach((el) => el.classList.add("js-fade-item"));
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          // 一度だけ出せばOKなら監視解除（再表示アニメ不要ならこれが軽い）
          io.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -10% 0px", // 少し手前で発火
      threshold: 0.15,               // 15%入ったら発火
    }
  );

  document.querySelectorAll(".js-fade-section").forEach((sec) => io.observe(sec));
})();